<template>
  <b-overlay :show="isLoading">
    <SelectComponent
        :options="types | idNameToValueLabel"
        :disabled="disabled"
        :searching="isLoading"
        @search="autocomplete"
        @input="evt => $emit('input', evt)"
    />
  </b-overlay>
</template>

<script>
import SelectComponent from "@/components/SelectComponent";
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "SelectTuevsType",
  components: {SelectComponent},
  props: {
    model: null,
    disabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters({
      isLoading: 'type/isLoading',
      types: 'type/all',
    })
  },
  data() {
    return {
      awaitingSearch: false
    }
  },
  methods: {
    ...mapActions([
      'type/listAll',
    ]),
    ...mapMutations([
      'type/setAll',
    ]),
    async autocomplete(string) {
      if (string.length >= 3 && !this.awaitingSearch) {
        setTimeout(() => {
          //TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
          this.temporallyStringPrepareToSQL('name', string).map(async array => {
            await this['type/listAll']({filters: [array]})
            await this['type/setAll'](this.types.data.data)
          })
          this.awaitingSearch = false
        }, 1000)
        this.awaitingSearch = true
      }
    },
    temporallyStringPrepareToSQL(field, valueTyped) {
      const string = valueTyped.toLowerCase()
      return [
        [field, 'LIKE', '%' + valueTyped + '%'],
        [field, 'LIKE', '%' + string + '%'],
        [field, 'LIKE', '%' + string.toUpperCase() + '%'],
        [field, 'LIKE', '%' + string.charAt(0).toUpperCase() + string.slice(1) + '%'],
      ]
    }
  },
  async mounted() {
    await this['type/listAll']()
    this['type/setAll'](this.types.data.data)
  }
}
</script>
